import { render, staticRenderFns } from "./DiceAnimator.vue?vue&type=template&id=4ea61522&scoped=true&lang=pug&"
import script from "./DiceAnimator.vue?vue&type=script&lang=ts&"
export * from "./DiceAnimator.vue?vue&type=script&lang=ts&"
import style0 from "./DiceAnimator.vue?vue&type=style&index=0&id=4ea61522&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea61522",
  null
  
)

component.options.__file = "DiceAnimator.vue"
export default component.exports